import React from 'react';
import { COLORS, Color } from '../../../styles/variables';

interface SUVDefaultIconProps {
  color?: Color;
}

const SUVDefaultIcon: React.FC<SUVDefaultIconProps> = ({ color = COLORS.black }) => (
  <svg width={76} height={38} fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)" stroke={color} strokeWidth={0.75} strokeMiterlimit={10}>
      <path d="M65.55 26.22a10 10 0 0 0 3.25-.68c2.65-1.2 2.14-4.28 2.14-4.79 0-.51-.77-1-.85-1.2a11.081 11.081 0 0 1-.69-2.73c.94-.77-.08-2.83-.17-3-.09-.17-6.5-4.62-6.41-4.87.42-.09.85-.17.85-.52s-13-2-17.11-2a51.35 51.35 0 0 0-8.63.51 17.47 17.47 0 0 0-4.37.95 81.858 81.858 0 0 0-9.58 5.64 59.001 59.001 0 0 0-15.65 2.91 5.56 5.56 0 0 0-2.74 2.82 25.8 25.8 0 0 0-.08 5.82c.17 1 4.19 1.37 5 1.45M26.2 26.23l23.35-.26" />
      <path d="M8.33 19.04c.42-.546.91-1.034 1.46-1.45a14.58 14.58 0 0 1 4-.6c.08 0 .25.17.17.25a7.48 7.48 0 0 1-2 1.8c-.34.09-2.91.09-3.51.17-.12 0-.12-.08-.12-.17ZM69.74 15.19a1.87 1.87 0 0 0-.68-.43l-3.25-.08a22.37 22.37 0 0 0 1.54 2.74 8.354 8.354 0 0 0 2.14-.52M60.95 12.8s-11.29.77-18.64 1c-7.35.23-15.83.69-15.83.69M43.57 8.1l-1.29 5.73M53.32 8.7l2.74 4.36M22.87 26.74c.005.083.005.167 0 .25a5.57 5.57 0 0 1-11.14 0 5.57 5.57 0 0 1 9.06-4.33M63.16 26.74v.25a5.57 5.57 0 1 1-10.716-2.13 5.559 5.559 0 0 1 5.146-3.43 5.53 5.53 0 0 1 3.49 1.23" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(5 6)" d="M0 0h66.35v26.94H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SUVDefaultIcon;
